import { render, staticRenderFns } from "./Correspondencia0.vue?vue&type=template&id=51591316&scoped=true&"
import script from "./Correspondencia0.vue?vue&type=script&lang=js&"
export * from "./Correspondencia0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51591316",
  null
  
)

export default component.exports